import React from "react";

import styles from './DifferenceCard.module.scss'

const DifferenceCard = ({ id, icon, title, text}) => {

    return (
        <div className={styles.container}>
            <div className={styles.icon_card}>
                <img className={styles.icon} src={icon} alt="icon"/>
            </div>

            <div className={styles.card}>
                <div className={styles.card_information}>
                    <div className={styles.title}>
                        {title}
                    </div>

                    <div className={styles.text}>
                        {text}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DifferenceCard;
